import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

import { usePubNubChannelHistory, usePubNubChannelListener } from "hooks";

import { MessageHistoryDisplay } from "./MessageHistoryDisplay";

import type { MessageEnvelope } from "@pubnub/react-chat-components";

interface Props {
  currentChannel: string;
  onHistoryLoaded?: () => void;
}

export function MessageHistoryDisplayContainer(props: Props) {
  const { currentChannel, onHistoryLoaded } = props;

  const [history, setHistory] = useState<MessageEnvelope[]>([]);
  const hasScrolledRef = useRef(false);

  const { messages } = usePubNubChannelHistory({
    channel: currentChannel,
  });

  const onNewMessage = useCallback((message: MessageEnvelope) => {
    setHistory((prevMessages) => [...prevMessages, message]);
  }, []);

  usePubNubChannelListener({
    channels: [currentChannel],
    onNewChannelMessage: onNewMessage,
    onNewFileMessage: onNewMessage,
  });

  useEffect(() => {
    hasScrolledRef.current = false;
  }, [currentChannel]);

  useEffect(() => {
    if (messages) {
      setHistory(messages);
    } else {
      setHistory([]);
    }
  }, [messages]);

  // useLayoutEffect fires before paint, so scroll position is set before the user sees the chat.
  useLayoutEffect(() => {
    if (!hasScrolledRef.current && history.length > 0) {
      hasScrolledRef.current = true;
      onHistoryLoaded?.();
    }
  }, [history, onHistoryLoaded]);

  return (
    <MessageHistoryDisplay messages={history} currentChannel={currentChannel} />
  );
}
